import { Icon, SvgCCOff, SvgCCOn } from '@loomhq/lens';
import React from 'react';

import ControlBarButton from '../control-bar-button';

export default function CcButton({ onClick, ccOn = false }) {
  const hoverTagText = ccOn
    ? 'Turn off closed captions'
    : 'Turn on closed captions';

  return (
    <ControlBarButton
      className="video-player-cc-button"
      hoverTagText={hoverTagText}
      onClick={onClick}
    >
      <div>
        <Icon
          className="control-bar-button"
          color="white"
          icon={ccOn ? <SvgCCOn /> : <SvgCCOff />}
        />
      </div>
    </ControlBarButton>
  );
}
